import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Add Ant Design so we have uniform styling across the
    app.
  </p>
    </div>
    <p>{`Ant Design is a component library that makes creating responsive websites super easy. Let's start by adding the ant design library:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save antd
`}</code></pre>
    <p>{`Now, we want to import the main css file in the root of the application. The `}<inlineCode parentName="p">{`_app.tsx`}</inlineCode>{` is a great place to put this import because it is loaded on every page so we can ensure that it will be loaded everywhere.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/_app.tsx"
      }}>{`import 'antd/dist/antd.css';
import App from 'next/app';

class MyApp extends App {
  render() {
    const { Component, pageProps } = this.props;
    return <Component {...pageProps} />;
  }
}

export default MyApp;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      